<template>
  <FormContainer @submitForm="saveCosto">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del costo"
        v-model="costo.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Importo annuo"
        v-model.number="costo.importo"
        :min="0"
        :errorMsg="errorHash['importo']"
        @input="removeError('importo')"
      />

      <FormInputSelectWidget
        class="col-lg-4 col-sm-6"
        label="Frequenza"
        v-model="costo.frequenza"
        :options="frequenze"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Aliquota IVA"
        v-model.number="costo.vat"
        :errorMsg="errorHash['vat']"
        @input="removeError('vat')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Variazione annuale"
        v-model.number="costo.delta"
        :errorMsg="errorHash['delta']"
        @input="removeError('delta')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Ritenuta fiscale"
        v-model.number="costo.ritenuta"
        :errorMsg="errorHash['ritenuta']"
        @input="removeError('ritenuta')"
      />

      <FormInputSelectDilazioneWidget
        class="col-lg-4 col-sm-6"
        label="Giorni di dilazione"
        v-model.number="costo.dilazione"
        :errorMsg="errorHash['dilazione']"
        @input="removeError('dilazione')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Mese del primo costo"
        v-model="costo.begin"
        :errorMsg="errorHash['begin']"
        @input="removeError('begin')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Ultimo mese del costo"
        not-required
        v-model="costo.end"
        :errorMsg="errorHash['end']"
        @input="removeError('end')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva costo
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  components: {
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    FormInputSelectDilazioneWidget: () => import('./Widgets/FormInputSelectDilazioneWidget'),
  },
  props: {
    costo: {
      type: Object,
      default: () => ({
        name: null,
        frequenza: 1,
        importo: null,
        dilazione: 0,
        delta: 0,
        vat: 22,
        ritenuta: 0,
        begin: null,
        end: null,
      }),
    },
    frequenze: {
      type: Array,
      default: () => [
        { value: 1, label: 'Mensile' },
        { value: 2, label: 'Bimensile' },
        { value: 3, label: 'Trimestrale' },
        { value: 4, label: 'Semestrale' },
        { value: 5, label: 'Annuale' },
      ],
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.costo.name) {
        this.addError('Il nome del costo è obbligatorio', 'name');
      }

      if (!this.costo.importo) {
        this.addError('L\'importo annuo è obbligatorio', 'importo');
      }

      if (!this.costo.vat && this.costo.vat !== 0) {
        this.addError('L\'aliquota iva è obbligatoria', 'vat');
      }

      if (!this.costo.delta && this.costo.delta !== 0) {
        this.addError('La variazione annuale è obbligatoria', 'delta');
      }

      if (!this.costo.ritenuta && this.costo.ritenuta !== 0) {
        this.addError('La ritenuta fiscale è obbligatoria', 'ritenuta');
      }

      if (!this.costo.begin) {
        this.addError('Il mese del primo costo è obbligatorio', 'begin');
      }

      if (this.costo.end && this.costo.end < this.costo.begin) {
        this.addError('Il mese dell\'ultimo mese deve essere successivo al primo', 'end');
      }

      return !this.hasErrors;
    },
    saveCosto () {
      if (!this.validate()) {
        return;
      }
      this.$emit('saved', this.costo);
    },
  },
};

</script>
